import { render } from "./OrderStatusComponent.vue?vue&type=template&id=c2761d5c&ts=true"
import script from "./OrderStatusComponent.vue?vue&type=script&lang=ts"
export * from "./OrderStatusComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__